import { CartIcon, createWebviewScreen } from 'shared/src/component';

/**
 * 프로필 화면(`/mypage/profile`, 내용은 웹뷰).
 *
 * 전용 화면으로 두는 이유는 Cart / OrderDetail 과 같다 — 범용 `WebViewScreen` 으로 열면
 * 목적지가 `url` params 문자열로 들어가 주소가 `/mypage/profile` 로 유지되지 않는다.
 * Navigator 에 `path` 로 등록해 주소를 유지한다.
 *
 * 경로·타이틀만 다른 웹뷰 화면이라 `createWebviewScreen`(shared) 팩토리로 만든다.
 */
export const MyProfileScreen = createWebviewScreen({
  screen: 'MyProfile',
  title: '프로필',
  showHeader: true,
  rightIcons: [<CartIcon />],
});
